import { ONE_SEC_IN_MS } from '../../application/constants/time';

export const HIDE_BUMPER_AFTER_MS = 60000 * ONE_SEC_IN_MS;
